import { initializeApp } from "firebase/app";
import { getFirestore, collection  } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBsbMAXpUz3hbpBppoLoZSzVaRigQlSERo",
  authDomain: "akhilasdeveloper-portfolio.firebaseapp.com",
  projectId: "akhilasdeveloper-portfolio",
  storageBucket: "akhilasdeveloper-portfolio.appspot.com",
  messagingSenderId: "299698733928",
  appId: "1:299698733928:web:98057bdae568f24f45ccdd",
  measurementId: "G-RCRBJJBNNN",
  databaseURL: "https://akhilasdeveloper-portfolio-default-rtdb.asia-southeast1.firebasedatabase.app"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app)
const storage = getStorage(app)
const mainCollection = collection(db, 'apps')
const dataCollection = collection(db, 'data')
const auth = getAuth(app);
export {mainCollection}
export {dataCollection}
export {storage}
export {auth}